// extracted by mini-css-extract-plugin
module.exports = {"img":"Loading_img__2ar3c"};